import { HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment"

export class BaseService {

    protected httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      };
 
    public rootUrl;
  
    constructor() {
      this.rootUrl = environment.APIURL;
      //this.rootUrl = configLoader.getConfiguration().apiUrl;
      //this.rootUrl = 'http://localhost:60194';
      //this.rootUrl = 'https://apitest.dcscouting.se';
      //this.rootUrl = 'https://api.dcscouting.se'; 
        //console.log(this.rootUrl);
     }  
     
}